// Persisted client settings. Ported from the reference games' game/settings.js.
// Keeps `sound`; adds `reducedMotion` (the reference's mobile `oneHanded` slot
// is game-specific). localStorage-backed, 'off' sentinel like the reference.

import { key } from "../gameId.ts";

const SOUND_KEY = key("sound");
const MOTION_KEY = key("reducedMotion");

// Fired whenever the sound toggle changes, `detail` carrying the new value —
// generic (no game-specific import here), so a game's own audio module (e.g.
// board-othellos's game/audio/bgm.ts) can listen and mute/unmute live.
export const SOUND_CHANGE_EVENT = "gz:soundchange";

export function getSoundOn(): boolean {
  return localStorage.getItem(SOUND_KEY) !== "off";
}
export function setSoundOn(on: boolean): void {
  try {
    localStorage.setItem(SOUND_KEY, on ? "on" : "off");
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(SOUND_CHANGE_EVENT, { detail: on }));
}

export function getReducedMotion(): boolean {
  const stored = localStorage.getItem(MOTION_KEY);
  if (stored === "on") return true;
  if (stored === "off") return false;
  return (
    typeof matchMedia === "function" &&
    matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}
export function setReducedMotion(on: boolean): void {
  try {
    localStorage.setItem(MOTION_KEY, on ? "on" : "off");
  } catch {
    /* ignore */
  }
  applyMotionAttr();
}

function applyMotionAttr(): void {
  if (typeof document !== "undefined") {
    document.documentElement.dataset.reducedMotion = String(getReducedMotion());
  }
}

/** Apply persisted settings at boot. */
export function applySettings(): void {
  applyMotionAttr();
}
